import React from 'react';
//import { Link } from 'react-router-dom';

const Footer = () =>{
    return(
        <footer className="bg-slate-900 text-white">
            <section className="max-w-7xl mx-auto">
                <div className="px-4 py-5 text-xs text-center lg:text-justify lg:flex lg:flex-row lg:justify-between lg:px-0">
                    <p className="w-auto">
                        Universidad de los Andes | Vigilada Mineducación<br/>
                        Reconocimiento como Universidad: Decreto 1297 del 30 de mayo de 1964.<br/>
                        Reconocimiento personería jurídica: Resolución 28 del 23 de febrero de 1949 Minjusticia
                    </p>
                    <p className="pt-3 lg:pt-0">© 2022 Departamento de Ingeniería de Sistemas y Computación</p>
                </div>
            </section>
        </footer>
    )
}

export default Footer;